



















import type { PropType } from '@nuxtjs/composition-api';
import { computed, defineComponent } from '@nuxtjs/composition-api';

interface MenuLayerData {
  id: string;
  pushBlocksWidth: 'small' | 'large';
  data: any[];
}

// TODO: Define proper types for 'data' prop
export default defineComponent({
  name: 'VaimoMenuLayer',
  components: {
    Menu: () => import('organisms/menu/Menu.vue'),
    EditorialPushItem: () =>
      import('templates/sections/EditorialPush/EditorialPushItem.vue')
  },
  props: {
    data: {
      required: false,
      type: Array as PropType<MenuLayerData[]>,
      default: () => []
    },
    currentNav: {
      required: false,
      type: String,
      default: ''
    }
  },
  emits: ['hide'],
  setup(props) {
    const sectionData = computed(() =>
      (props.data[0]?.data || []).filter(Boolean)
    );

    const pushBlockClasses = computed<string>(() => {
      const width = props.data?.[0]?.pushBlocksWidth || 'small';
      return `push-blocks-width--${width}`;
    });

    return {
      sectionData,
      pushBlockClasses
    };
  }
});
